import React, { useEffect, useMemo } from 'react';
import { disableCoreApiOverride, getCoreApiOverrideInfo } from '../utils/coreApiOverride';

const CoreApiCanaryBanner = () => {
  const info = useMemo(() => getCoreApiOverrideInfo(), []);

  useEffect(() => {
    if (!info?.active) return;
    // Make it very hard to miss in DevTools.
    // eslint-disable-next-line no-console
    console.warn('[KG] CANARY CORE API ENABLED:', info.origin);
  }, [info]);

  if (!info?.active) return null;

  return (
    <div className="kg-api-canary-banner alert alert-warning d-flex align-items-center justify-content-between mb-0">
      <div className="me-3">
        <strong>CANARY CORE API ENABLED</strong>: {info.origin}
      </div>
      <button type="button" className="btn btn-sm btn-outline-dark" onClick={disableCoreApiOverride}>
        Disable
      </button>
    </div>
  );
};

export default CoreApiCanaryBanner;

